(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["expandable-product-title"] && !Shopify.designMode) return;
  try {
    class ExpandableProductTitle extends HTMLElement {
    connectedCallback() {
      this.heading = this.querySelector('h1');
      this.toggle = this.querySelector('.expandable-product-title__chevron');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.expanded = false;

      if (!this.heading || !this.toggle) return;

      this.handleActivation = this.handleActivation.bind(this);
      this.sync = this.sync.bind(this);

      this.addEventListener('click', this.handleActivation);
      this.mobileQuery.addEventListener?.('change', this.sync);
      window.addEventListener('resize', this.sync, { passive: true });

      this.sync();
      document.fonts?.ready.then(this.sync);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivation);
      this.mobileQuery?.removeEventListener?.('change', this.sync);
      window.removeEventListener('resize', this.sync);
    }

    handleActivation(event) {
      if (event.type === 'click' && !this.mobileQuery.matches) return;
      if (this.dataset.overflowing !== 'true') return;
      this.setExpanded(!this.expanded);
    }

    sync() {
      if (!this.heading) return;

      if (!this.mobileQuery.matches) {
        this.expanded = false;
        this.heading.style.height = 'auto';
        this.removeAttribute('data-overflowing');
        this.removeAttribute('data-expanded');
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.setAttribute('aria-label', 'Show full product title');
        return;
      }

      this.heading.style.height = 'auto';
      const fullHeight = this.heading.scrollHeight;
      const computed = getComputedStyle(this.heading);
      const lineHeight = Number.parseFloat(computed.lineHeight) || Number.parseFloat(computed.fontSize) * 1.2;
      const collapsedHeight = Math.ceil(lineHeight);
      const overflowing = fullHeight > collapsedHeight + 2;

      this.dataset.overflowing = String(overflowing);

      if (!overflowing) {
        this.expanded = false;
        this.heading.style.height = 'auto';
        this.removeAttribute('data-expanded');
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.setAttribute('aria-label', 'Show full product title');
        return;
      }

      this.collapsedHeight = collapsedHeight;
      this.toggle.setAttribute('aria-expanded', String(this.expanded));
      this.toggle.setAttribute('aria-label', this.expanded ? 'Hide full product title' : 'Show full product title');
      this.dataset.expanded = String(this.expanded);
      this.heading.style.height = this.expanded ? 'auto' : `${collapsedHeight}px`;
    }

    setExpanded(expanded) {
      if (!this.heading || this.dataset.overflowing !== 'true') return;

      this.expanded = expanded;
      this.dataset.expanded = String(expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.setAttribute('aria-label', expanded ? 'Hide full product title' : 'Show full product title');

      if (expanded) {
        this.heading.style.height = `${this.collapsedHeight}px`;
        const fullHeight = this.heading.scrollHeight;
        requestAnimationFrame(() => {
          this.heading.style.height = `${fullHeight}px`;
        });

        this.heading.addEventListener(
          'transitionend',
          () => {
            if (this.expanded) this.heading.style.height = 'auto';
          },
          { once: true }
        );
      } else {
        this.heading.style.height = `${this.heading.scrollHeight}px`;
        this.heading.getBoundingClientRect();
        requestAnimationFrame(() => {
          this.heading.style.height = `${this.collapsedHeight}px`;
        });
      }
    }
  }

  if (!customElements.get('expandable-product-title')) {
    customElements.define('expandable-product-title', ExpandableProductTitle);
  }
  } catch(e) { console.error(e); }
})();

})();
